import {
  JOIN_LIST_SEARCH, JOIN_LIST_SEARCH_FAILURE, JOIN_LIST_SEARCH_SUCCESS, JOIN_DELETE, JOIN_DELETE_FAILURE, JOIN_DELETE_SUCCESS
} from './mutation-types'

export default {
  state: {
    joins: [],
    joinListNextPage: null,
    joinListCurrentPage: null
  },
  getters: {
    joinList: state => {
      return state.joins
    },
    joinListNextPage: state => {
      return state.joinListNextPage
    },
    joinListCurrentPage: state => {
      return state.joinListCurrentPage
    }
  },
  actions: {
    [JOIN_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/joins'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(JOIN_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(JOIN_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [JOIN_DELETE] ({dispatch, state, commit}, params = null) {
      console.log('JOIN_DELETE:' + params.id)
      var data = params.data
      var url = '/master/joins/' + params.id
      dispatch('apiDelete', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(JOIN_DELETE_FAILURE, res.data)
          } else {
            commit(JOIN_DELETE_SUCCESS, {data: res.data, callback: params.callback})
            window.location.reload(false)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [JOIN_LIST_SEARCH_FAILURE] (state, params) {
      console.log('JOIN_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [JOIN_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('JOIN_LIST_SEARCH_SUCCESS')
      var data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.joins = state.domains.concat(data.data)
        state.joinListCurrentPage = data.meta['current-page']
      } else {
        state.joins = data.data
        state.joinListCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.joinListNextPage = data.links['next']
      } else {
        state.joinListNextPage = null
      }
      if (params.callback) {
        params.callback()
      }
    },
    [JOIN_DELETE_FAILURE] (state, data) {
      console.log('JOIN_DELETE_FAILURE')
    },
    [JOIN_DELETE_SUCCESS] (state, data) {
      console.log('JOIN_DELETE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/join-list.js